import { RouterModule } from '@angular/router';
import { Component, ElementRef, HostListener, OnDestroy, OnInit, signal, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Table, TableLazyLoadEvent, TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { RatingModule } from 'primeng/rating';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
// import { Product, ProductService } from '../service/product.service';
import { Product, ProductService } from '../pages/service/product.service';
import { MenuItem } from 'primeng/api';
import { ContextMenu, ContextMenuModule } from 'primeng/contextmenu'; // ✅ Import this
import { AutoComplete, AutoCompleteCompleteEvent, AutoCompleteModule, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { finalize, takeUntil } from 'rxjs/operators';
import { AppTopbar } from '../layout/component/app.topbar';
import { OrderDraftService } from '../services/order-draft.service'; // Import your service for order drafts
// If you're using PrimeNG table
// ✅ Import MenuItem
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject, debounceTime, distinctUntilChanged, switchMap } from 'rxjs';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';

import { RoleAccessService } from '../auth/role-access.service';
import { UserRole } from '../auth/roles.enum';
import { AppFeature } from '../auth/features.enum';
import { InMemoryStorageService } from '../services/in-memory-storage.service';
import { environment } from '../../environments/environment';
import { getPersistedItemDetailsVersion, itemDetailsRouteCommands } from '../item-details/item-details-routing.util';
import { UserService } from '../pages/service/user.service';
import { CalendarModule } from 'primeng/calendar';
import { DatePickerModule } from 'primeng/datepicker';
import { Dropdown, DropdownModule } from 'primeng/dropdown';
import { ProgressSpinner } from 'primeng/progressspinner';
// import {pFrozenColumn} from

interface Column {
    field: string;
    header: string;
    customExportHeader?: string;
}

interface ExportColumn {
    title: string;
    dataKey: string;
}

@Component({
    selector: 'app-crud',
    standalone: true,
    imports: [
        DropdownModule,
        AutoCompleteModule,
        CalendarModule,
        DatePickerModule,
        RouterModule,
        CommonModule,
        TableModule,
        FormsModule,
        ButtonModule,
        ContextMenuModule,
        RippleModule,
        ToastModule,
        ToolbarModule,
        RatingModule,
        InputTextModule,
        TextareaModule,
        SelectModule,
        RadioButtonModule,
        InputNumberModule,
        DialogModule,
        TagModule,
        InputIconModule,
        IconFieldModule,
        ConfirmDialogModule,
        TooltipModule,
    ],
    templateUrl: './display.component.html',
    styleUrls: ['./display.component.css'],
    providers: [MessageService, ProductService, ConfirmationService]
})
export class DisplayComponent implements OnInit, OnDestroy {
    onTablePage(event: any) {
        const page = Math.floor(event.first / event.rows);
        const size = event.rows;
        const sortField = event.sortField;
        const sortOrder = event.sortOrder === 1 ? 'ASC' : 'DESC';
        const filters = event.filters; // contains global and column filters

        // Pass these to your API
        this.loadOrderHeaders(page, size, sortField, sortOrder, filters);
    }
    loaderMessageLine1 = 'Loading...';
    loaderMessageLine2 = 'Please wait...';

    addresses: { label: string; addressId: any; full: any }[] = [];
    filteredAddresses: { label: string; addressId: any; full: any }[] = [];
    todayStr: string | number | undefined;

    onWarehouseSelect($event: AutoCompleteSelectEvent) {
        this.loading = true;
        this.loaderMessageLine1 = 'Loading Warehouse  details...';
        this.loaderMessageLine2 = 'Please wait...';
        console.log('Warehouse selected:', $event.value);
        const selectedWarehouse = $event.value;
        this.selectedWarehouseCountryCode = selectedWarehouse?.cscd || '';
        console.log('Selected warehouse country code:', this.selectedWarehouseCountryCode);
        this.calculateVatPercentage();
        setTimeout(() => {
            this.loading = false;
        }, 100);
    }
    onFacilitySelect($event: AutoCompleteSelectEvent) {
        throw new Error('Method not implemented.');
    }

    statusHelpDialog: boolean = false; // <-- Add this line
    @HostListener('window:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        if (this.draftDialogVisible) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        if (event.altKey && (event.key === 'n' || event.key === 'N')) {
            event.preventDefault();
            this.openNew();
        }
        if (event.altKey && (event.key === 'r' || event.key === 'R')) {
            event.preventDefault();
            this.openRouteWisePickingList();
        }
        if (event.altKey && (event.key === 's' || event.key === 'S')) {
            event.preventDefault();
            this.onSyncAllOrders();
        }
    }

    openRouteWisePickingList() {
        this.router.navigate(['/customize-picking-list']);
    }

    onAddressSelect($event: AutoCompleteSelectEvent) {
        // Ensure product is initialized
        if (!this.product) {
            this.product = {} as Product;
        }
        // Assuming $event contains the address object from the API
        console.log('Address selected:', $event.value);

        const address = $event.value;
        const addressId = address.addressId;
        const addressName = [address.addressLine1, address.addressLine2, address.addressLine3, address.addressLine4].filter(Boolean).join(', ');
        if (addressId && addressName) {
            localStorage.setItem(addressId, addressName);
            this.product.addressId = addressId;
            this.product.address = addressName;
            console.log(`Stored addressId: ${addressId}, addressName: ${addressName} in localStorage`);
            console.log('Assigned addressId to product:', this.product.addressId);
        } else {
            console.warn('Address ID or Name is missing, cannot store in localStorage');
            // Clear addressId if not valid
            this.product.addressId = '';
        }
        // ...existing code for handling address selection...
    }
    salesManagement() {
        this.router.navigate(['/dashboard']);
    }
    isFocused: boolean = false;
    loading: boolean = false;
    productDialog: boolean = false;
    selectedProduct!: Product;
    contextMenuItems!: MenuItem[];
    // @ViewChild(AppTopbar) appTopBar!: AppTopbar;

    // products = signal<Product[]>([]);
    product: Product = {} as Product;

    selectedProducts: Product[] | null = null;

    //  products: Product[] = [];

    products = signal<Product[]>([]);
    submitted: boolean = false;

    @ViewChild('cm') cm!: ContextMenu;

    statuses!: any[];

    @ViewChild('dt') dt!: Table;

    exportColumns!: ExportColumn[];

    cols!: Column[];
    customers: string[] = [];
    filteredCustomers: string[] = [];
    facilities: any[] = [];
    warehouses: any[] = [];
    today = new Date().toISOString().slice(0, 10);
    // addresses: string[] = [];
    // filteredAddresses: string[] = [];
    filteredStatuses: string[] = [];

    categories: string[] = []; // facility
    orderType: any[] = [];

    filteredCategories: string[] = [];

    filteredFacilities: string[] = [];
    filteredOrderType: string[] = [];
    filteredWarehouses: string[] = [];
    customerSuggestions: unknown;
    selectedCustomer: any;
    customerOptions: any;
    selectedCustomerDetails: any = null;
    facilityLoading = false;
    warehouseLoading = false;
    orderTypeLoading = false;
    @ViewChild('proceedButton') proceedButton!: ElementRef;
    private destroy$ = new Subject<void>();
    constructor(
        private router: Router,
        private productService: ProductService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private http: HttpClient,
        private orderDraftService: OrderDraftService,
        private inMemoryStorage: InMemoryStorageService, // <-- Add this

        private roleAccessService: RoleAccessService, // <-- Add this
        public userService: UserService // Inject UserService
    ) {
        this.setupCustomerSearch();
    }
    confirmInvoiceDialogVisible = false;
    item: any;
    selectedOrderNumber: string = '';
    selectedCustomerName: string = '';

    exportPdfDialogVisible = false;
    exportFromDate: string = this.getTodayDate();
    exportToDate: string = this.getTodayDate();
    exportPdfLoading = false;
    openExportPdfDialog() {
        this.exportFromDate = this.getTodayDate();
        this.exportToDate = this.getTodayDate();
        this.exportPdfDialogVisible = true;
    }
    // onExportPdf() {
    //     if (new Date(this.exportToDate) > new Date(this.getTodayDate())) {
    //         this.messageService.add({
    //             severity: 'error',
    //             summary: 'Invalid Date',
    //             detail: 'To Date cannot exceed today.'
    //         });
    //         return;
    //     }
    //     this.exportPdfLoading = true;
    //     const company = this.inMemoryStorage.get('company') || '781';
    //     const division = this.inMemoryStorage.get('division') || '400';
    //     const apiUrl = `${environment.apiUrl}api/excel-export/orders?company=${company}&division=${division}&fromDate=${this.exportFromDate}&toDate=${this.exportToDate}`;
    //     this.http.get(apiUrl, { responseType: 'blob' }).subscribe({
    //         next: (blob) => {
    //             this.exportPdfLoading = false;
    //             const url = window.URL.createObjectURL(blob);
    //             const a = document.createElement('a');
    //             a.href = url;
    //             a.download = `orders_${this.exportFromDate}_${this.exportToDate}.xlsx`; // <-- Change to .xlsx
    //             a.click();
    //             window.URL.revokeObjectURL(url);
    //             this.exportPdfDialogVisible = false;
    //             this.messageService.add({
    //                 severity: 'success',
    //                 summary: 'Export Successful',
    //                 detail: 'Excel exported successfully.'
    //             });
    //         },
    //         error: (err) => {
    //             this.exportPdfLoading = false;
    //             this.messageService.add({
    //                 severity: 'error',
    //                 summary: 'Export Failed',
    //                 detail: 'Failed to export PDF.'
    //             });
    //         }
    //     });
    // }

    // In your component class
    exportExportType: 'lines' | 'headers' = 'lines'; // default to lines

    onExportPdf() {
        if (new Date(this.exportToDate) > new Date(this.getTodayDate())) {
            this.messageService.add({
                severity: 'error',
                summary: 'Invalid Date',
                detail: 'To Date cannot exceed today.'
            });
            return;
        }
        this.exportPdfLoading = true;
        const company = this.inMemoryStorage.get('company') || '781';
        const division = this.inMemoryStorage.get('division') || '400';

        let apiUrl = '';
        let filename = '';
        if (this.exportExportType === 'lines') {
            // Order Headers + Lines
            apiUrl = `${environment.apiUrl}orders-export/HeaderAndLines?fromDate=${this.exportFromDate}&toDate=${this.exportToDate}&company=${company}&division=${division}`;
            filename = `orders_with_lines_${this.exportFromDate}_${this.exportToDate}.xlsx`;
        } else {
            // Order Headers Only
            apiUrl = `${environment.apiUrl}excel-export/orders?company=${company}&division=${division}&fromDate=${this.exportFromDate}&toDate=${this.exportToDate}`;
            filename = `orders_headers_${this.exportFromDate}_${this.exportToDate}.xlsx`;
        }

        this.http.get(apiUrl, { responseType: 'blob' }).subscribe({
            next: (blob) => {
                this.exportPdfLoading = false;
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = filename;
                a.click();
                window.URL.revokeObjectURL(url);
                this.exportPdfDialogVisible = false;
                this.messageService.add({
                    severity: 'success',
                    summary: 'Export Successful',
                    detail: 'Excel exported successfully.'
                });
            },
            error: (err) => {
                this.exportPdfLoading = false;
                this.messageService.add({
                    severity: 'error',
                    summary: 'Export Failed',
                    detail: 'Failed to export Excel.'
                });
            }
        });
    }

    openPickingList(orderNumber: string, customerName: string) {
        const companyId = this.inMemoryStorage.get('company') || '';
        const divisionId = this.inMemoryStorage.get('division') || '';
        const currentUsername = this.userService.getUserName();
        const product = this.products().find((p) => p.orderNumber === orderNumber);
        // referenceOrderId + M3 Hi/Lo status + warehouse for France Process Picklist.
        this.item = {
            orderNumber,
            customerName,
            companyId,
            divisionId,
            referenceOrderId: product?.referenceOrderId ?? '',
            m3HighestStatus: product?.m3HighestStatus ?? '',
            m3LowestStatus: product?.m3LowestStatus ?? '',
            warehouseId: product?.warehouseId || this.inMemoryStorage.get('warehouseId') || ''
        };
        console.log('Opening Picking List');
        console.log('Navigating to Picking List', orderNumber);
        console.log(this.item);

        this.productService.acquireOrderLock(orderNumber, companyId, divisionId, currentUsername).subscribe({
            next: (res: any) => {
                this.messageService.add({ severity: 'success', summary: 'Lock Acquired', detail: res?.message || 'Order is now locked for editing.', life: 2000 });
                this.router.navigate(['/picking-list'], {
                    state: { item: this.item }
                });
            },
            error: (err) => {
                let msg = typeof err.error === 'string' ? err.error : err.error?.message || 'Could not acquire lock.';
                this.messageService.add({ severity: 'warn', summary: 'Order Already Locked', detail: msg, life: 4000 });
            }
        });
    }
    generateInvoice(orderNumber: string, customerName: string) {
        this.item = { orderNumber: orderNumber, customerName: customerName };
        const companyId = this.inMemoryStorage.get('company') || '';
        const divisionId = this.inMemoryStorage.get('division') || '';
        const currentUsername = this.userService.getUserName();
        console.log('Opening Picking List');

        console.log('Navigating to Picking List', orderNumber);
        // this.router.navigate(['/picking-list'], {
        //     state: { item: this.item }
        // });

        this.productService.acquireOrderLock(orderNumber, companyId, divisionId, currentUsername).subscribe({
            next: (res: any) => {
                this.messageService.add({ severity: 'success', summary: 'Lock Acquired', detail: res?.message || 'Order is now locked for editing.', life: 2000 });
                this.router.navigate(['/generate-invoice'], {
                    state: { item: this.item }
                });
            },
            error: (err) => {
                let msg = typeof err.error === 'string' ? err.error : err.error?.message || 'Could not acquire lock.';
                this.messageService.add({ severity: 'warn', summary: 'Order Already Locked', detail: msg, life: 4000 });
            }
        });
    }
    showInvoiceConfirm(orderNumber: string, orderMovingStatus: string, customerName: string) {
        console.log(orderMovingStatus);
        this.selectedOrderNumber = orderNumber; // <-- Add this line
        this.selectedCustomerName = customerName; // <-- Add this line
        // If already invoiced, show popup only once
        if (orderMovingStatus === 'INV') {
            this.generateInvoice(orderNumber, customerName);

            return; // Do not show the confirm dialog
        }

        this.confirmInvoiceDialogVisible = true;
    }

    exportCSV() {
        this.dt.exportCSV();
    }
    canAccess = false;
    isManagerOrSuperUser = false;
    isSalesPerson = false;
    userRoles: string[] = [];
    division: string = '';

    private navigateToItemDetails(id: string, extras: { state?: any } = {}): void {
        const version = getPersistedItemDetailsVersion(this.division);
        this.router.navigate(itemDetailsRouteCommands(version, id), extras);
    }

    ngOnInit() {
        this.division = this.inMemoryStorage.get('division') || '';

        const hasOrders = !!localStorage.getItem('orders');
        const hasOrderLines = !!localStorage.getItem('orderLines');

        if (hasOrders && !hasOrderLines) {
            console.log('Removing orders and orderLines from localStorage');
            localStorage.removeItem('orders');
            localStorage.removeItem('orderLines');
            localStorage.removeItem('routeParams');
            this.orderDraftService.clearDraft();
        } else if (!hasOrders && hasOrderLines) {
            console.log('Removing orderLines from localStorage');
            localStorage.removeItem('orderLines');
            localStorage.removeItem('orders');
            localStorage.removeItem('routeParams');
            this.orderDraftService.clearDraft();
        }
        console.log('today:', this.today); // Should log 'yyyy-MM-dd'
        const userRoles: UserRole[] = JSON.parse(this.inMemoryStorage.get('roleGroup') || '[]');
        this.userRoles = JSON.parse(this.inMemoryStorage.get('roleGroup') || '[]');
        this.canAccess = this.roleAccessService.hasAccess(userRoles, AppFeature.ManageOrders);
        console.log('Loaded userRoles:', this.userRoles);
        this.isManagerOrSuperUser = this.userRoles.includes('sales_manager_group') || this.userRoles.includes('admin_group');
        this.isSalesPerson = this.userRoles.includes('sales_person_group');
        console.log('isManagerOrSuperUser:', this.isManagerOrSuperUser);
        console.log('isSalesPerson:', this.isSalesPerson);

        if (!this.canAccess) {
            this.router.navigate(['/']);
            return;
        }
        this.showDraftDialogIfNeeded();
        if (this.draftDialogVisible) {
            // Stop further initialization until user interacts with the draft dialog
            return;
        }
        console.log({ ...localStorage });

        console.log(this.product);

        const customerId = 'someCustomerId'; // Replace with actual logic to get customerId
        const customerName = localStorage.getItem(customerId);

        if (customerName) {
            console.log(`Retrieved customerName: ${customerName} for customerId: ${customerId}`);
        } else {
            console.warn(`No customerName found for customerId: ${customerId}`);
        }

        this.loadOrderHeaders();
        console.log(this.product);

        setTimeout(() => {
            // localStorage.setItem('products', JSON.stringify(this.products()));
            // this.setupAutoSearch();
            console.log('data', JSON.stringify(this.products(), null, 2));
        }, 0); // slight delay to ensure products are loaded

        // Only show sync/don't sync options for divisionsToProcessAfterCutover
        const afterCutoverDivisions = (environment.divisionsToProcessAfterCutover || '').split(',').map((d) => d.trim());

        // Get division from UserService
        const currentDivision = this.userService.getDivisionId?.() || '';

        this.contextMenuItems = [
            {
                label: 'Hold from M3 Sync',
                icon: 'pi pi-times-circle',
                command: () => {
                    // Only allow for selected row with status 10
                    if (!this.selectedProduct || !this.selectedProduct.orderNumber) {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'No Order Selected',
                            detail: 'Please select an order to update.',
                            life: 2000
                        });
                        return;
                    }
                    if (this.selectedProduct.status !== 10) {
                        this.messageService.add({
                            severity: 'warn',
                            summary: 'Invalid Status',
                            detail: 'Order status must be 10 to mark as "Hold from M3 Sync".',
                            life: 4000
                        });
                        return;
                    }
                    this.confirmationService.confirm({
                        message: 'Are you sure you want to mark this order as "Hold from M3 Sync"?',
                        header: 'Confirm Don’t Sync',
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            this.productService
                                .updateOrderHeaderStatus(this.selectedProduct.orderNumber, 9, 'CustomerOrder')
                                .pipe(takeUntil(this.destroy$))
                                .subscribe({
                                    next: () => {
                                        this.messageService.add({
                                            severity: 'success',
                                            summary: 'Order Updated',
                                            detail: 'Order marked as "Hold from M3 Sync".',
                                            life: 2000
                                        });
                                        this.refreshOrders();
                                    },
                                    error: (err) => {
                                        // Treat HTTP 200 in error as success
                                        if (err && err.status === 200) {
                                            this.messageService.add({
                                                severity: 'success',
                                                summary: 'Order Updated',
                                                detail: 'Order marked as "Hold from M3 Sync".',
                                                life: 2000
                                            });
                                            this.refreshOrders();
                                        } else {
                                            this.messageService.add({
                                                severity: 'error',
                                                summary: 'Update Failed',
                                                detail: 'Failed to update order status.',
                                                life: 3000
                                            });
                                        }
                                    }
                                });
                        }
                    });
                }
            },
            {
                label: 'Allow Sync to M3',
                icon: 'pi pi-cloud-upload',
                command: () => {
                    // Only allow for selected row with status 9
                    if (!this.selectedProduct || !this.selectedProduct.orderNumber) {
                        this.messageService.add({
                            severity: 'error',
                            summary: 'No Order Selected',
                            detail: 'Please select an order to update.',
                            life: 2000
                        });
                        return;
                    }
                    if (this.selectedProduct.status !== 9) {
                        this.messageService.add({
                            severity: 'warn',
                            summary: 'Invalid Status',
                            detail: 'Order status must be 9 to Allow Sync to M3.',
                            life: 2000
                        });
                        return;
                    }
                    this.confirmationService.confirm({
                        message: 'Are you sure you want to Allow Sync to M3?',
                        header: 'Confirm Allow Sync',
                        icon: 'pi pi-exclamation-triangle',
                        accept: () => {
                            this.productService
                                .updateOrderHeaderStatus(this.selectedProduct.orderNumber, 10, 'CustomerOrder')
                                .pipe(takeUntil(this.destroy$))
                                .subscribe({
                                    next: () => {
                                        this.messageService.add({
                                            severity: 'success',
                                            summary: 'Order Synced',
                                            detail: 'Order status updated to 10 (Synced to M3).',
                                            life: 2000
                                        });
                                        this.refreshOrders();
                                    },
                                    error: (err) => {
                                        // Treat HTTP 200 in error as success
                                        if (err && err.status === 200) {
                                            this.messageService.add({
                                                severity: 'success',
                                                summary: 'Order Synced',
                                                detail: 'Order status updated to 10 (Allow Sync to M3).',
                                                life: 3000
                                            });
                                            this.refreshOrders();
                                        } else {
                                            this.messageService.add({
                                                severity: 'error',
                                                summary: 'Sync Failed',
                                                detail: 'Failed to sync order to M3.',
                                                life: 3000
                                            });
                                        }
                                    }
                                });
                        }
                    });
                }
            },
            // ...other menu items...

            {
                label: 'Status Help',
                icon: 'pi pi-question-circle',
                command: () => {
                    this.statusHelpDialog = true;
                }
            }
        ];
    }
    currentPage = 0;
    pageSize = 20;
    totalElements = 0;
    totalPages = 0;
    orderHeaders: any[] = [];

    loadOrderHeaders(page: number = 0, size: number = 30, sortField: string = '', sortOrder: string = 'DESC', filters: any = {}) {
        const userProfile = JSON.parse(this.inMemoryStorage.get('userProfile') || '{}');
        this.loading = true;
        this.loaderMessageLine1 = 'Loading order Data...';
        this.loaderMessageLine2 = 'Please wait...';
        this.productService
            // .getOrderHeaders(page, size, 'DESC', 'CustomerOrder')
            .getOrderHeaders(0, 10000, 'DESC', 'CustomerOrder')
            .pipe(finalize(() => (this.loading = false)))
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (res) => {
                    console.log('Order headers API response:', res.content[0]?.userIdResponsible);
                    let orderHeaders = Array.isArray(res) ? res : res && res.content ? res.content : [];
                    this.currentPage = res.pageNumber;
                    this.pageSize = res.pageSize;
                    this.totalElements = res.totalElement;
                    this.totalPages = res.totalPages;
                    console.log('Order headers API response:', orderHeaders);
                    if (this.isSalesPerson && !this.isManagerOrSuperUser && userProfile.userName) {
                        orderHeaders = orderHeaders.filter((item: any) => item.userIdResponsible === userProfile.userName);
                    }
                    orderHeaders = orderHeaders.map((item: any) => {
                        const requestedDateStr = item.requestedDate || '';
                        const requestedDateObj = requestedDateStr ? new Date(requestedDateStr) : null;
                        const customerName = localStorage.getItem(item.customerId);
                        // --- Address name resolution logic ---
                        let addressValue = item.addressName || item.address || item.addressId || '';
                        // If addressValue looks like an ID, try to get the name from localStorage
                        let addressNameFromStorage = '';
                        if (addressValue && typeof addressValue === 'string' && /^[0-9A-Za-z]+$/.test(addressValue)) {
                            addressNameFromStorage = localStorage.getItem(addressValue) || '';
                        }
                        // Prefer addressNameFromStorage if found
                        if (addressNameFromStorage) {
                            addressValue = addressNameFromStorage;
                        }
                        // -------------------------------------
                        return {
                            id: item.id || item.orderHeaderId || item.orderNumber || '',
                            orderNumber: item.orderNumber || 'NOT PRESENT',
                            referenceOrderId: item.referenceOrderId || '',
                            customer: customerName || item.customerId || '',
                            address: addressValue,
                            status: item.status ?? null,
                            orderType: item.orderTypeName || item.orderType || item.orderTypeId || '',
                            facility: item.facilityName || item.facility || item.facilityId || '',
                            warehouse: item.whsName || item.warehouse || item.whsId || '',
                            requestedDate: item.requestedDate || '',
                            name: item.name || customerName || 'No Name Available',
                            userIdResponsible: item.userIdResponsible || '',
                            grossValue: item.grossValue ?? null,
                            totalDiscountValue: item.totalDiscountValue ?? null,
                            netAmount: item.netAmount ?? null,
                            vatAmount: item.vatAmount ?? null,
                            orderValue: item.orderValue ?? null,
                            customerName: item.customerName || customerName || 'No Name Available',
                            errorMessage: item.errorMessage || item.errorMessages || '',
                            orderMovingStatus: item.orderMovingStatus || '',
                            requestedDateStr, // For display
                            requestedDateObj // For sorting/filtering
                        };
                    });
                    console.log(orderHeaders.length, 'Order headers loaded:', orderHeaders);
                    if (orderHeaders.length === 0) {
                        this.messageService.add({
                            severity: 'warn',
                            summary: 'No Orders Found',
                            detail: 'No order data available for the selected User.',
                            life: 2000
                        });
                    } else {
                        this.messageService.add({
                            severity: 'success',
                            summary: 'Order Details Loaded',
                            detail: 'Order Data loaded successfully.',
                            life: 1000
                        });
                    }
                    this.products.set(orderHeaders);
                },
                error: (err) => {
                    this.loading = false;
                    this.products.set([]);
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: 'Failed to load order Data.',
                        life: 3000
                    });
                    console.error('Order headers API error:', err);
                }
            });
    }
    onRowSelect(event: any) {
        this.selectedProduct = event.data;
        console.log('Row selected:', this.selectedProduct);
    }

    // onDisplay() {
    //     console.log('triggered');

    //     if (this.selectedProduct) {
    //         console.log('Selected Product:', this.selectedProduct);

    //         this.product.name = this.selectedCustomer?.CUNM || 'No Name Available';
    //         console.log('Product Name:', this.product.name); // Debugging
    //         // Try to extract addressId from address field if it's an object, or use as string
    //         let addressId = '';
    //         if (typeof this.selectedProduct.address === 'object' && this.selectedProduct.address !== null && 'addressId' in this.selectedProduct.address) {
    //             addressId = (this.selectedProduct.address as { addressId?: string }).addressId || '';
    //         } else if (typeof this.selectedProduct.address === 'string') {
    //             addressId = this.selectedProduct.address;
    //         }
    //         this.router.navigate(['/item', this.selectedProduct.id], {
    //             state: {
    //                 product: this.selectedProduct,
    //                 customerData: {
    //                     CUNO: this.selectedCustomer?.CUNO,
    //                     CUNM: this.selectedCustomer?.CUNM
    //                 },
    //                 name: this.product.name,
    //                 addressId: addressId // Pass addressId if present
    //             }
    //         });
    //         console.log(this.product.name);
    //     } else {
    //         console.warn('No product selected');
    //     }
    // }
    onDisplay(product: Product, event?: Event) {
        if (event) {
            event.preventDefault(); // Prevent default anchor navigation
        }
        this.selectedProduct = product;

        const orderNumber = product.orderNumber;
        const companyId = this.inMemoryStorage.get('company') || '';
        const divisionId = this.inMemoryStorage.get('division') || '';
        const currentUsername = this.userService.getUserName();

        this.productService.acquireOrderLock(orderNumber, companyId, divisionId, currentUsername).subscribe({
            next: (res: any) => {
                this.messageService.add({ severity: 'success', summary: 'Lock Acquired', detail: res?.message || 'Order is now locked for editing.', life: 3000 });
                // Now navigate to item details
                this.product.name = this.selectedCustomer?.CUNM || 'No Name Available';
                let addressId = '';
                if (typeof product.address === 'object' && product.address !== null && 'addressId' in product.address) {
                    addressId = (product.address as { addressId?: string }).addressId || '';
                } else if (typeof product.address === 'string') {
                    addressId = product.address;
                }
                this.navigateToItemDetails(String(product.id), {
                    state: {
                        product: product,
                        customerData: {
                            CUNO: this.selectedCustomer?.CUNO,
                            CUNM: this.selectedCustomer?.CUNM
                        },
                        name: this.product.name,
                        addressId: addressId
                    }
                });
            },
            error: (err) => {
                let msg = typeof err.error === 'string' ? err.error : err.error?.message || 'Could not acquire lock.';
                this.messageService.add({ severity: 'warn', summary: 'Order Already Locked', detail: msg, life: 4000 });
            }
        });
    }
    onUpdate() {
        if (this.selectedProduct) {
            this.router.navigate(['/update'], { state: { product: this.selectedProduct } });
        }
    }

    onDelete() {
        console.log('triggered');

        if (this.selectedProduct) {
            this.router.navigate(['/delete', this.selectedProduct.id], {
                state: { product: this.selectedProduct }
            });
        } else {
        }
    }

    onRightClick(event: MouseEvent, product: Product) {
        event.preventDefault();
        this.selectedProduct = product;

        // Dynamically filter context menu items for status 10 only
        this.cm.model = this.contextMenuItems.filter((item) => {
            if (item.label === 'Hold from M3 Sync' && product.status !== 10) {
                return false;
            }
            if (item.label === 'Allow Sync to M3' && product.status !== 9) {
                return false;
            }
            return true;
        });

        this.cm.show(event);
    }

    onRowRightClick(event: any) {
        event.preventDefault();
        this.selectedProduct = event.data;

        // Dynamically filter context menu items for status 10 only
        this.cm.model = this.contextMenuItems.filter((item) => {
            if ((item.label === 'Don’t sync this order to M3' || item.label === 'Sync this order to M3') && event.data.status !== 10) {
                return false;
            }
            return true;
        });

        this.cm.show(event.originalEvent);
    }

    viewProduct(product: Product) {
        this.messageService.add({
            severity: 'info',
            summary: 'Product Info',
            detail: `Name: ${product.name}, Price: ${product.price}`
        });
    }

    onGlobalFilter(table: Table, event: Event) {
        console.log('Global filter event:', event.target);
        console.log('table:', table.value);

        table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
        setTimeout(() => {
            const filtered = table.value || [];
            console.log('Filtered table data:', filtered);

            if (filtered.length > 0) {
                console.log('Match found:', filtered.length, 'rows');
            } else {
                console.log('No match found');
            }
        }, 0);
    }

    openNew() {
        console.log('Opening new product dialog');
        console.log('Initial product state:', this.product);
        localStorage.removeItem('orders');
        localStorage.removeItem('orderLines');
        localStorage.removeItem('routeParams');
        this.orderDraftService.clearDraft();
        setTimeout(() => {
            console.log('Focusing on customer field');
            if (this.customerField && this.customerField.inputEL) {
                console.log('Customer field found, focusing on it');

                this.customerField.inputEL.nativeElement.focus();
            }
        }, 400);
        const facilityId = this.inMemoryStorage.get('facilityId'); // Default to '1234' if not set]
        const warehouseId = this.inMemoryStorage.get('warehouseId'); // Default to '1234' if not set
        this.selectedCustomer = null;
        // Set today's date in 'yyyy-mm-dd' format for requestedDate
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        this.todayStr = `${yyyy}-${mm}-${dd}`;
        this.product = {
            name: '',
            description: '',
            inventoryStatus: '',
            category: '',
            requestedDate: this.todayStr, // <-- set today's date
            addressId: '',
            address: '',
            facilityId: facilityId,
            warehouseId: warehouseId,
            orderTypeId: '',
            quantity: 0
        } as Product;
        this.selectedCustomer = null;
        this.selectedCustomerDetails = null;
        this.addresses = [];
        this.filteredAddresses = [];
        this.categories = [];
        this.filteredCategories = [];
        this.warehouses = [];
        this.filteredWarehouses = [];
        this.filteredStatuses = [];
        this.orderType = [];
        this.submitted = false;
        this.productDialog = true;
        // Focus the Select Customer field after a short delay to ensure dialog is rendered
    }

    editProduct(product: any) {
        // Ensure product is initialized
        if (!product) {
            product = {} as Product;
        }
        console.log('Editing product:', product);

        const customer = product.customer; // Assuming this is the ID

        this.selectedCustomer = product.customerName;
        console.log('Selected Customer:', this.selectedCustomer);

        // Clone the product and add customerName
        this.product = {
            ...product,
            name: customer || '',
            addressId: product.addressId || '',
            facilityId: product.facilityId || product.facility || '',
            warehouseId: product.warehouseId || product.warehouse || product.whsId || '',
            orderTypeId: product.orderTypeId || product.orderType || ''
        };
        console.log('Product to edit:', this.product);

        this.productDialog = true; // Open the dialog for editing
    }

    deleteSelectedProducts() {
        this.confirmationService.confirm({
            message: 'Are you sure you want to delete the selected products?',
            header: 'Confirm',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.products.set(this.products().filter((val) => !this.selectedProducts?.includes(val)));
                this.selectedProducts = null;
                this.messageService.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Products Deleted',
                    life: 3000
                });
            }
        });
    }

    hideDialog() {
        this.productDialog = false;
        this.submitted = false;
    }
    @ViewChild('customerField') customerField!: AutoComplete;
    @ViewChild('addressField') addressField!: AutoComplete;
    @ViewChild('orderTypeField') orderTypeField!: AutoComplete;
    @ViewChild('facilityField') facilityField!: AutoComplete;
    @ViewChild('warehouseField') warehouseField!: AutoComplete;
    @ViewChild('requestedDateField') requestedDateField!: ElementRef;
    @ViewChild('submitButton') submitButton!: ElementRef;
    focusSubmitButton() {
        if (this.submitButton && this.submitButton.nativeElement) {
            this.submitButton.nativeElement.focus();
        }
    }
    focusNext(field: string) {
        const autoComplete = this[field as keyof this] as AutoComplete;
        const inputEl = autoComplete?.inputEL?.nativeElement;

        if (inputEl) {
            inputEl.focus();
        }
    }

    focusAddressInput() {
        const input = this.addressField?.el?.nativeElement?.querySelector('input');
        if (input) {
            input.focus();
        }
    }
    focusOrderTypeInput() {
        const input = this.orderTypeField?.el?.nativeElement?.querySelector('input');
        if (input) {
            input.focus();
        }
    }
    focusFacilityInput() {
        const input = this.facilityField?.el?.nativeElement?.querySelector('input');
        if (input) {
            input.focus();
        }
    }
    focusWarehouseInput() {
        const input = this.warehouseField?.el?.nativeElement?.querySelector('input');
        if (input) {
            input.focus();
        }
    }

    findIndexById(id: string): number {
        let index = -1;
        for (let i = 0; i < this.products().length; i++) {
            if (this.products()[i].id === id) {
                index = i;
                break;
            }
        }

        return index;
    }

    createId(): string {
        let id = '';
        var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        for (var i = 0; i < 5; i++) {
            id += chars.charAt(Math.floor(Math.random() * chars.length));
        }
        return id;
    }

    saveProduct() {
        // Ensure product is initialized
        if (!this.product) {
            this.product = {} as Product;
        }
        this.submitted = true;

        // If address is an object, extract label and addressId for validation and saving
        const addressObj = this.product.address && typeof this.product.address === 'object' ? this.product.address : null;
        const addressLabel = this.product.address || '';
        const addressId = this.product.addressId || '';

        // Validation: require all fields
        if (!this.product.customer || !this.product.facilityId || !this.product.warehouseId || !this.product.orderTypeId || !this.product.requestedDate) {
            this.messageService.add({
                severity: 'error',
                summary: 'Missing Required Fields',
                detail: 'Please fill all required fields before proceeding.',
                life: 4000
            });
            return;
        }

        // Ensure the name is assigned before validation
        if (!this.product.name) {
            this.product.name = this.selectedCustomer?.CUNM || 'No Name Available';
        }

        // Debug: print all relevant fields before validation
        console.log('saveProduct fields:', {
            customer: this.product.customer,
            address: addressLabel,
            addressId: addressId,
            facilityId: this.product.facilityId,
            warehouseId: this.product.warehouseId,
            orderTypeId: this.product.orderTypeId,
            requestedDate: this.product.requestedDate,
            quantity: this.product.quantity,
            name: this.product.name
        });

        let _products = this.products();

        // Always update product.address and product.addressId to be correct before saving
        this.product.address = addressLabel;
        console.log('Address label to save:', addressLabel);
        if (addressLabel && typeof addressLabel === 'object') {
            console.log('Address label is an object, extracting label property:', addressLabel);
            //        const extractedLabel = addressLabel.label;
            //   const extractedAddressId = addressLabel.addressId;

            //   console.log("Extracted Label:", extractedLabel);
            //   console.log("Extracted Address ID:", extractedAddressId);
        }
        console.log(this.addresses);

        this.product.addressId = addressId;
        console.log('Address ID to save:', addressId);

        if (this.product.id) {
            // Update existing product
            const index = this.findIndexById(this.product.id);
            if (index !== -1) {
                _products[index] = this.product;
                this.products.set([..._products]);
                this.messageService.add({
                    severity: 'success',
                    summary: 'Successful',
                    detail: 'Product Updated',
                    life: 3000
                });
            }
        } else {
            // Create new product
            this.product.id = this.createId();
            this.products.set([..._products, this.product]);
            this.messageService.add({
                severity: 'success',
                summary: 'Successful',
                detail: 'Product Created',
                life: 3000
            });
        }

        // Map dialog fields to orderHeader with correct property names
        const orderHeader = {
            name: this.product.name,
            customer: this.product.customer || '',
            address: addressLabel,
            addressId: addressId,
            facilityId: this.product.facilityId || '',
            warehouseId: this.product.warehouseId || '',
            orderTypeId: this.product.orderTypeId || '',
            requestedDate: this.product.requestedDate || '',
            quantity: this.product.quantity || 0
        };
        console.log('Order Header to save:', orderHeader);
        console.log('Product to save:', this.product);

        // Save to localStorage so display component sees the new data
        // localStorage.setItem('products', JSON.stringify(this.products()));

        localStorage.setItem('routeParams', JSON.stringify(this.product.id));
        // Close dialog before navigating
        this.productDialog = false;
        // Navigate to item details for the new/updated product, passing orderHeader
        this.navigateToItemDetails(String(this.product.id), { state: { product: this.product, orderHeader } });
    }

    // saveProduct() {
    //     // Ensure product is initialized
    //     if (!this.product) {
    //         this.product = {} as Product;
    //     }
    //     this.submitted = true;

    //     // If address is an object, extract label and addressId for validation and saving
    //     const addressObj = this.product.address && typeof this.product.address === 'object' ? this.product.address : null;
    //     // const addressLabel = this.product.address || '';
    //     const addressId = this.product.addressId || '';
    //     // const addressLabel = this.product.address as { label?: string; addressId?: string; full?: any };
    //     // const extractedLabel = addressLabel.label;
    //     // const extractedAddressId = addressLabel.addressId;

    //     // console.log('Extracted Label:', extractedLabel);
    //     // console.log('Extracted Address ID:', extractedAddressId);
    //     // Validation: require all fields
    //     if (!this.product.customer || !this.product.facilityId || !this.product.warehouseId || !this.product.orderTypeId || !this.product.requestedDate) {
    //         this.messageService.add({
    //             severity: 'error',
    //             summary: 'Missing Required Fields',
    //             detail: 'Please fill all required fields before proceeding.',
    //             life: 4000
    //         });
    //         return;
    //     }

    //     // Ensure the name is assigned before validation
    //     if (!this.product.name) {
    //         this.product.name = this.selectedCustomer?.CUNM || 'No Name Available';
    //     }

    //     // Debug: print all relevant fields before validation
    //     console.log('saveProduct fields:', {
    //         customer: this.product.customer,
    //         addressId: addressId,
    //         facilityId: this.product.facilityId,
    //         warehouseId: this.product.warehouseId,
    //         orderTypeId: this.product.orderTypeId,
    //         requestedDate: this.product.requestedDate,
    //         quantity: this.product.quantity,
    //         name: this.product.name
    //     });

    //     let _products = this.products();

    //     // Always update product.address and product.addressId to be correct before saving
    //     const addressLabel = this.product.address as { label?: string; addressId?: string; full?: any };
    //     const extractedLabel = addressLabel.label || '';
    //     const extractedAddressId = addressLabel.addressId || '';

    //     console.log('Extracted Label:', extractedLabel);
    //     console.log('Extracted Address ID:', extractedAddressId);

    //     // Always store the label (string) in product.address
    //     this.product.address = extractedLabel;
    //     this.product.addressId = extractedAddressId;
    //     console.log('Address label to save:', addressLabel);
    //     // if (addressLabel && typeof addressLabel === 'object') {
    //     //     console.log('Address label is an object, extracting label property:', addressLabel);
    //     //     const extractedLabel = addressLabel.label;
    //     //     const extractedAddressId = addressLabel.addressId;

    //     //     console.log('Extracted Label:', extractedLabel);
    //     //     console.log('Extracted Address ID:', extractedAddressId);
    //     // }

    //     this.product.addressId = extractedAddressId;
    //     console.log('Address ID to save:', extractedAddressId);

    //     if (this.product.id) {
    //         // Update existing product
    //         const index = this.findIndexById(this.product.id);
    //         if (index !== -1) {
    //             _products[index] = this.product;
    //             this.products.set([..._products]);
    //             this.messageService.add({
    //                 severity: 'success',
    //                 summary: 'Successful',
    //                 detail: 'Product Updated',
    //                 life: 3000
    //             });
    //         }
    //     } else {
    //         // Create new product
    //         this.product.id = this.createId();
    //         this.products.set([..._products, this.product]);
    //         this.messageService.add({
    //             severity: 'success',
    //             summary: 'Successful',
    //             detail: 'Product Created',
    //             life: 3000
    //         });
    //     }

    //     // Map dialog fields to orderHeader with correct property names
    //     const orderHeader = {
    //         name: this.product.name,
    //         customer: this.product.customer || '',
    //         address: addressLabel,
    //         addressId: addressId,
    //         facilityId: this.product.facilityId || '',
    //         warehouseId: this.product.warehouseId || '',
    //         orderTypeId: this.product.orderTypeId || '',
    //         requestedDate: this.product.requestedDate || '',
    //         quantity: this.product.quantity || 0
    //     };
    //     console.log('Order Header to save:', orderHeader);
    //     console.log('Product to save:', this.product);

    //     // Save to localStorage so display component sees the new data
    //     // localStorage.setItem('products', JSON.stringify(this.products()));

    //     localStorage.setItem('routeParams', JSON.stringify(this.product.id));
    //     // Close dialog before navigating
    //     this.productDialog = false;
    //     // Navigate to item details for the new/updated product, passing orderHeader
    //     this.router.navigate(['/item', this.product.id], { state: { product: this.product, orderHeader } });
    // }

    filterCustomers(event: any) {
        const query = event.query;

        if (query.length >= 3) {
            this.productService
                .searchCustomers(query)
                .pipe(takeUntil(this.destroy$))
                .subscribe((res: any) => {
                    if (Array.isArray(res)) {
                        this.customerOptions = res;
                    } else if (res) {
                        this.customerOptions = [res];
                    } else {
                        this.customerOptions = [];
                    }
                });
        } else {
            this.customerOptions = [];
        }
    }

    onCustomerSelect(event: any) {
        console.log('Customer selected:', event);
        this.loading = true;
        this.loaderMessageLine1 = 'Loading customer details...';
        this.loaderMessageLine2 = 'Please wait...';

        // Ensure product is initialized
        if (!this.product) {
            this.product = {} as Product;
        }
        const customerObj = event.value;
        if (!customerObj) {
            this.clearCustomerFields();
            return;
        }
        this.product.name = customerObj.CUNM || 'No Name Available';
        const customerId = customerObj?.CUNO || customerObj?.customerId || customerObj?.id || customerObj;
        console.log('Extracted customerId for details API:', customerId);

        if (customerId && typeof customerId === 'string') {
            this.product.customer = customerId;
            // Reset product fields
            this.product.requestedDate = this.todayStr;
            this.product.address = '';
            this.product.addressId = '';
            this.product.facilityId = '';
            this.product.warehouseId = '';
            this.product.orderTypeId = '';
            this.product.quantity = 0;
            this.product.id = this.product.id || '';
            this.product.description = undefined;
            this.product.category = undefined;
            this.product.price = undefined;
            this.product.inventoryStatus = undefined;

            this.productDialog = true;
            this.selectedCustomerDetails = null;
            this.addresses = [];
            this.filteredAddresses = [];
            this.categories = [];
            this.filteredCategories = [];
            this.warehouses = [];
            this.filteredWarehouses = [];
            this.filteredStatuses = [];
            const facilityId = this.inMemoryStorage.get('facilityId');
            const warehouseId = this.inMemoryStorage.get('warehouseId');

            this.productService.getCustomerDetails(customerId, facilityId).subscribe({
                next: (details) => {
                    console.log('Customer details API response:', details);
                    this.loading = false;

                    let addresses: { label: string; addressId: any; full: any }[] = [];

                    if (Array.isArray(details.addresses) && details.addresses.length > 0) {
                        console.log('Processing multiple addresses:1', details.addresses);

                        addresses = details.addresses.map((addr: any) => ({
                            label: [addr.addressLine1, addr.addressLine2, addr.addressLine3, addr.addressLine4].filter(Boolean),
                            addressId: addr.addressId,
                            full: addr
                        }));
                        console.log('Processed addresses:', addresses);
                    } else if (Array.isArray(details) && details.length > 0) {
                        console.log('Processing multiple addresses from array22:', details);

                        addresses = details.map((addr: any) => ({
                            label: [addr.addressLine1, addr.addressLine2, addr.addressLine3, addr.addressLine4].filter(Boolean).join(', '),
                            addressId: addr.addressId,
                            full: addr
                        }));
                        console.log('Processed addresses:', addresses);
                    } else if (details.addressLine1) {
                        console.log('Processing single address3:', details);

                        addresses = [
                            {
                                label: [details.addressLine1, details.addressLine2, details.addressLine3, details.addressLine4].filter(Boolean).join(', '),
                                addressId: details.addressId,
                                full: details
                            }
                        ];
                        console.log('Processed addresses:', addresses);
                    }

                    // Assign to component properties

                    // Set default address and addressId if available
                    if (addresses.length > 0) {
                        const mappedAddresses = addresses.map((a) => ({
                            ...a,
                            label: Array.isArray(a.label) ? a.label.filter(Boolean).join(', ') : a.label
                        }));
                        console.log('Mapped Addresses:', mappedAddresses);

                        this.addresses = mappedAddresses;
                        this.filteredAddresses = [mappedAddresses[0]]; // Pre-populate first address
                        this.product.address = mappedAddresses[0].label;
                        this.product.addressId = mappedAddresses[0].addressId;
                        this.product.addressCountryCode = mappedAddresses[0].full?.countryCode || '';

                        console.log('Filtered Addresses:', this.filteredAddresses);
                        console.log('Product Address:', this.product.address);
                        console.log('Product AddressId:', this.product.addressId);
                        console.log('Addresses:', this.addresses);
                        console.log('Product after setting address:', this.product.addressCountryCode);
                    } else {
                        this.product.address = '';
                        this.product.addressId = '';
                    }

                    // Set other product fields from details
                    if (details.addresses && details.addresses.length > 0) {
                        this.product.phoneNumber = details.addresses[0].phoneNumber || '';
                        this.product.customerAddress = details.addresses[0].combinedAddress;
                    } else if (details.phoneNumber || details.combinedAddress) {
                        this.product.phoneNumber = details.phoneNumber || '';
                        this.product.customerAddress = details.combinedAddress || '';
                    } else {
                        this.product.phoneNumber = '';
                        this.product.customerAddress = '';
                    }

                    this.product.phoneNumber = details.addresses?.[0]?.phoneNumber || '';
                    this.product.countryCode = details.addresses?.[0]?.countryCode || '';
                    this.product.customerAddress = details.addresses?.[0]?.combinedAddress || '';
                    this.product.vatRegistrationNo = details.vrno || '';
                    this.product.outstanding = details.outstanding || 0;
                    this.product.totalOverdue = details.totalOverdue || 0;
                    this.product.defaultPriceList = details.defaultPriceList || '';
                    this.product.pltb = details.pltb || '';
                    this.product.cucd = details.cucd || '';
                    this.product.cfc4 = details.cfc4 || '';
                    this.product.txap = details.txap || '';

                    // Facility, warehouse, order type
                    console.log('Setting facilityId, warehouseId, orderTypeId:', details.ortp);
                    console.log('Setting facilityId, warehouseId, orderTypeId:', details.ORDERTYPE);
                    console.log('Setting facilityId, warehouseId, orderTypeId:', details.orderType);

                    this.product.orderTypeId = details.ortp || details.ORDERTYPE || details.orderType || '';

                    this.product.requestedDate = this.todayStr;
                    this.product.facilityId = facilityId;
                    this.fetchFacilities();
                    this.fetchWarehouses();
                    this.fetchOrderTypes();
                    setTimeout(() => {
                        // this.calculateVatPercentage();
                    }, 300);
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Customer details loaded',
                        detail: `Details loaded for customer ${customerId}`,
                        life: 2000
                    });
                },
                error: (err) => {
                    this.loading = false;
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: `Failed to load customer details for id: ${customerId}`,
                        life: 3000
                    });
                    console.error('Customer details API error:', err);
                }
            });
        } else {
            this.messageService.add({
                severity: 'error',
                summary: 'Error',
                detail: 'No valid customerId found in selected customer.',
                life: 4000
            });
            console.error('No valid customerId found in selected customer:', customerObj);
        }
        this.selectedCustomer = customerObj;
    }
    onFacilityChange(newFacilityId: string) {
        // Only trigger if a customer is already selected
        if (this.selectedCustomer && newFacilityId) {
            this.loading = true; // Show loader
            this.loaderMessageLine1 = 'Loading customer details...';
            this.loaderMessageLine2 = 'Please wait...';

            // Call onCustomerSelect with the updated facility
            const customerId = this.selectedCustomer?.CUNO || this.selectedCustomer?.customerId || this.selectedCustomer?.id || this.selectedCustomer;
            console.log('Updating customer details for facility change:', customerId, newFacilityId);
            this.productService.getCustomerDetails(customerId, newFacilityId).subscribe({
                next: (details) => {
                    this.loading = false; // Hide loader
                    console.log('Customer details API response:', details);

                    let addresses: { label: string; addressId: any; full: any }[] = [];

                    if (Array.isArray(details.addresses) && details.addresses.length > 0) {
                        console.log('Processing multiple addresses:1', details.addresses);

                        addresses = details.addresses.map((addr: any) => ({
                            label: [addr.addressLine1, addr.addressLine2, addr.addressLine3, addr.addressLine4].filter(Boolean),
                            addressId: addr.addressId,
                            full: addr
                        }));
                        console.log('Processed addresses:', addresses);
                    } else if (Array.isArray(details) && details.length > 0) {
                        console.log('Processing multiple addresses from array22:', details);

                        addresses = details.map((addr: any) => ({
                            label: [addr.addressLine1, addr.addressLine2, addr.addressLine3, addr.addressLine4].filter(Boolean).join(', '),
                            addressId: addr.addressId,
                            full: addr
                        }));
                        console.log('Processed addresses:', addresses);
                    } else if (details.addressLine1) {
                        console.log('Processing single address3:', details);

                        addresses = [
                            {
                                label: [details.addressLine1, details.addressLine2, details.addressLine3, details.addressLine4].filter(Boolean).join(', '),
                                addressId: details.addressId,
                                full: details
                            }
                        ];
                        console.log('Processed addresses:', addresses);
                    }

                    // Assign to component properties

                    // Set default address and addressId if available
                    if (addresses.length > 0) {
                        const mappedAddresses = addresses.map((a) => ({
                            ...a,
                            label: Array.isArray(a.label) ? a.label.filter(Boolean).join(', ') : a.label
                        }));
                        this.addresses = mappedAddresses;
                        this.filteredAddresses = [mappedAddresses[0]]; // Pre-populate first address
                        this.product.address = mappedAddresses[0].label;
                        this.product.addressId = mappedAddresses[0].addressId;
                        this.product.addressCountryCode = mappedAddresses[0].full?.countryCode || '';
                        console.log('Filtered Addresses:', this.filteredAddresses);
                        console.log('Product Address:', this.product.address);
                        console.log('Product AddressId:', this.product.addressId);
                        console.log('Product Address Country Code:', this.product.addressCountryCode);
                        console.log('Addresses:', this.addresses);
                    } else {
                        this.product.address = '';
                        this.product.addressId = '';
                    }

                    // Set other product fields from details
                    if (details.addresses && details.addresses.length > 0) {
                        this.product.phoneNumber = details.addresses[0].phoneNumber || '';
                        this.product.customerAddress = details.addresses[0].combinedAddress;
                    } else if (details.phoneNumber || details.combinedAddress) {
                        this.product.phoneNumber = details.phoneNumber || '';
                        this.product.customerAddress = details.combinedAddress || '';
                    } else {
                        this.product.phoneNumber = '';
                        this.product.customerAddress = '';
                    }
                    this.product.phoneNumber = details.addresses?.[0]?.phoneNumber || '';
                    this.product.countryCode = details.addresses?.[0]?.countryCode || '';
                    this.product.customerAddress = details.addresses?.[0]?.combinedAddress || '';
                    this.product.vatRegistrationNo = details.vrno || '';
                    this.product.outstanding = details.outstanding || 0;
                    this.product.totalOverdue = details.totalOverdue || 0;
                    this.product.defaultPriceList = details.defaultPriceList || '';
                    this.product.pltb = details.pltb || '';
                    this.product.cucd = details.cucd || '';
                    this.product.cfc4 = details.cfc4 || '';
                    this.product.txap = details.txap || '';
                    const warehouseId = this.inMemoryStorage.get('warehouseId');
                    // Facility, warehouse, order type
                    this.product.facilityId = newFacilityId;
                    this.product.warehouseId = warehouseId;
                    this.product.orderTypeId = details.ortp || details.ORDERTYPE || details.orderType || '';
                    this.product.requestedDate = this.todayStr;

                    // this.fetchFacilities();
                    // this.fetchWarehouses();
                    // this.fetchOrderTypes();
                    this.messageService.add({
                        severity: 'success',
                        summary: 'Customer details loaded',
                        detail: `Details loaded for customer ${customerId}`,
                        life: 2000
                    });
                },
                error: (err) => {
                    this.loading = false; // Hide loader
                    this.messageService.add({
                        severity: 'error',
                        summary: 'Error',
                        detail: `Failed to load customer details for id: ${customerId}`,
                        life: 4000
                    });
                    console.error('Customer details API error:', err);
                }
            });
        }
    }

    // Add this method to clear all fields when customer is removed
    clearCustomerFields() {
        this.product = {
            customer: '',
            address: '',
            facility: '',
            warehouse: '',
            orderType: '',
            requestedDate: '',
            quantity: 0,
            Name: ''
        } as any;
        this.selectedCustomerDetails = null;
        this.addresses = [];
        this.filteredAddresses = [];
        this.categories = [];
        this.filteredCategories = [];
        this.warehouses = [];
        this.filteredWarehouses = [];
        this.filteredStatuses = [];
        this.orderType = [];
    }

    filterAddresses(event: any) {
        console.log('Filtering addresses with query:', event);

        const query = event.query ? event.query.toLowerCase() : '';
        this.filteredAddresses = this.addresses.filter((a) => a.label.toLowerCase().includes(query));
        console.log('Filtered Addresses:', this.addresses);
        console.log(this.product.address);
    }
    onAddressChanged(event: any) {
        this.loaderMessageLine1 = 'Loading address details...';
        this.loaderMessageLine2 = 'Please wait...';
        this.loading = true;
        console.log('Address changed by user:', event);
        console.log('Current product address before change:', this.product.addressId);

        console.log(this.product.address);

        if (typeof this.product.address === 'object') {
            const addressLabel = this.product.address as { label?: string; addressId?: string; full?: any };
            const combinedAddress = addressLabel.full.combinedAddress || '';
            const extractedLabel = addressLabel.label;
            const extractedAddressId = addressLabel.addressId;

            this.product.customerAddress = combinedAddress;
            this.product.address = extractedLabel || '';
            this.product.addressId = extractedAddressId || '';
            this.product.addressCountryCode = addressLabel.full?.countryCode || '';
            console.log('Combined Address:', combinedAddress);
            console.log('Extracted Label:', extractedLabel);
            console.log('Extracted Address ID:', extractedAddressId);
            console.log('Product after address change:', this.product.addressCountryCode);
        } else {
            console.log('Address is a string:', this.product.address);
        }
        // console.log(addr?.addressId);

        setTimeout(() => {
            this.loading = false;
        }, 200);
        this.calculateVatPercentage();

        // You can also log the selected addressId or label if needed:
        // console.log('Selected addressId:', event.addressId);s
        // console.log('Selected address label:', event.label);
    }

    filterCategories(event: any) {
        const query = event.query.toLowerCase();
        this.filteredCategories = this.categories.filter((f) => typeof f === 'string' && f.toLowerCase().includes(query));
    }

    // filterStatuses(event: any) {
    //     const query = event.query?.toLowerCase() || '';
    //     // const statuses = Array.isArray(this.statuses) ? this.statuses : [];
    //     this.filteredStatuses = this.orderType.filter((s) => typeof s === 'string' && s.toLowerCase().includes(query));
    // }

    private searchTerms = new Subject<string>();

    setupCustomerSearch() {
        this.searchTerms
            .pipe(
                //   debounceTime(300),
                distinctUntilChanged(),
                switchMap((term) => (term ? this.productService.searchCustomers(term) : []))
            )
            .pipe(takeUntil(this.destroy$))
            .subscribe((results) => {
                console.log('API Response:', results);
                this.customerOptions = results;
            });
    }

    onCustomerInput(event: any) {
        const query = event.query;
        if (query) {
            this.searchTerms.next(query);
        } else {
            this.customerSuggestions = [];
        }
    }

    // Optional: focus to next input
    goBack() {
        this.router.navigate(['/item-details']);
    }

    // Add this method to be called by the refresh button
    refreshOrders() {
        this.loadOrderHeaders();
    }

    onSyncOrder(product: any) {
        console.log('Sync clicked', product);
        this.confirmationService.confirm({
            message: 'Are you sure you want to submit the order?',
            header: 'Confirm Submission',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.productService
                    .getOrderHeader(product.orderNumber, 'CustomerOrder')
                    .pipe(takeUntil(this.destroy$))
                    .subscribe({
                        next: (headerResp) => {
                            const header = Array.isArray(headerResp) ? headerResp[0] : headerResp;
                            // Defensive: check if header exists and has required fields
                            if (!header || !header.orderNumber) {
                                this.messageService.add({
                                    severity: 'error',
                                    summary: 'Order Header Error',
                                    detail: 'Order header not found or invalid. Cannot confirm order.',
                                    life: 4000
                                });
                                return;
                            }
                            const confirmBody = {
                                orderId: header.orderId || '',
                                companyId: header.companyId || product.companyId,
                                orderNumber: header.orderNumber || product.orderNumber,
                                divisionId: header.divisionId || product.divisionId,
                                customerId: header.customerId || product.customerId,
                                customerName: header.customerName || product.customerName,

                                addressId: header.addressId || product.addressId,
                                orderTypeId: header.orderTypeId || product.orderTypeId,
                                referenceOrderId: header.referenceOrderId || product.referenceOrderId,
                                status: header.status || product.status,
                                facilityId: header.facilityId || product.facilityId,
                                whsId: header.whsId || product.whsId,
                                requestedDate: header.requestedDate || product.requestedDate,
                                userIdResponsible: header.userIdResponsible || product.userIdResponsible,
                                grossValue: header.grossValue || product.grossValue,
                                totalDiscountValue: header.totalDiscountValue || product.totalDiscountValue,
                                netAmount: header.netAmount || product.netAmount,
                                vatAmount: header.vatAmount || product.vatAmount,
                                customerAddress: header.customerAddress || product.customerAddress,
                                phoneNumber: header.phoneNumber || product.phoneNumber,
                                orderValue: header.orderValue || product.orderValue,
                                outstanding: header.outstanding || product.outstanding,
                                totalOverdue: header.totalOverdue || product.totalOverdue
                            };
                            // Log the confirmBody and endpoint for debugging
                            console.log('Confirm Order Body:', confirmBody);
                            this.productService
                                .confirmOrder(confirmBody, 'CustomerOrder')
                                .pipe(takeUntil(this.destroy$))
                                .subscribe({
                                    next: () => {
                                        this.messageService.add({
                                            severity: 'success',
                                            summary: 'Order Confirmed',
                                            detail: 'Order has been successfully submitted.',
                                            life: 2000
                                        });
                                        // Optionally refresh data here
                                    },
                                    error: (err) => {
                                        // Show backend error message if available
                                        const detail = err?.error?.Message || err?.error?.message || 'Failed to confirm the order.';
                                        this.messageService.add({
                                            severity: 'error',
                                            summary: 'Order Confirmation Failed',
                                            detail
                                        });
                                        // Log error for debugging
                                        console.error('Confirm Order API error:', err);
                                    }
                                });
                        },
                        error: (err) => {
                            // Show backend error message if available
                            const detail = err?.error?.Message || err?.error?.message || 'Failed to fetch order header.';
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Order Header Error',
                                detail
                            });
                            // Log error for debugging
                            console.error('GetOrderHeader API error:', err);
                        }
                    });
            }
        });
    }
    draftDialogVisible = false;

    showDraftDialogIfNeeded() {
        const draftOrder = localStorage.getItem('orders');
        const draftOrderLines = localStorage.getItem('orderLines');
        const routeParams = localStorage.getItem('routeParams');
        console.log('routeParams:', routeParams);
        console.log('draftOrder:', draftOrder);
        console.log('draftOrderLines:', draftOrderLines);

        if (draftOrder && draftOrderLines) {
            this.draftDialogVisible = true;
        }
    }

    discardDraft() {
        localStorage.removeItem('orders');
        localStorage.removeItem('orderLines');
        localStorage.removeItem('routeParams');
        this.orderDraftService.clearDraft();
        this.draftDialogVisible = false;
        this.loadOrderHeaders(); // Now load the manage orders data
    }
    onDraftDialogHide() {
        // this.loadOrderHeaders();

        // Only load orders if the user closed the dialog without continuing the draft
        if (localStorage.getItem('orders') || localStorage.getItem('orderLines')) {
            // User closed the dialog without discarding, so do NOT load orders
            // (You may want to show the dialog again or do nothing)
            // Optionally, you can clear the dialog state here if needed
        } else {
            // Draft was discarded, so load orders
            // this.loadOrderHeaders();
        }
    }

    //     draftOrder = JSON.parse(localStorage.getItem('orders') || '{}');
    // draftOrderLines = JSON.parse(localStorage.getItem('orderLines') || '[]');

    continueDraft() {
        const draftOrder = localStorage.getItem('orders');
        const draftOrderLines = localStorage.getItem('orderLines');
        const routeParams = JSON.parse(localStorage.getItem('routeParams') || '{}');
        console.log(draftOrder);
        console.log(draftOrderLines);
        console.log(routeParams);
        console.log('Continuing draft with:', {
            draftOrder,
            draftOrderLines,
            routeParams
        });

        // Set data in the shared service
        this.orderDraftService.orderHeader = draftOrder ? JSON.parse(draftOrder) : null;
        this.orderDraftService.orderLines = draftOrderLines ? JSON.parse(draftOrderLines) : [];
        console.log('Draft order and lines set in service:', {
            orderHeader: this.orderDraftService.orderHeader,
            orderLines: this.orderDraftService.orderLines
        });
        const orderNumber = this.orderDraftService.orderHeader[0]?.orderNumber || '';
        console.log(this.orderDraftService.orderHeader);
        console.log(this.orderDraftService.orderLines);

        setTimeout(() => {
            const orderNumber1 = this.orderDraftService.orderHeader[0]?.orderNumber || '';

            console.log('Navigating to item with orderNumber:', orderNumber1);
        }, 1000);

        // Navigate
        if (routeParams && !orderNumber) {
            console.log('Navigating to item with routeParams:', routeParams);
            this.navigateToItemDetails(String(routeParams));
        } else if (orderNumber) {
            this.navigateToItemDetails(String(orderNumber));
            console.log('Navigating to item with orderNumber:', orderNumber);
        } else {
            // Prevent invalid item route (route requires :id)
            this.router.navigate(['/Orders1']);
            console.log('Missing route params/order number. Staying on Orders page.');
        }
    }

    fetchFacilities() {
        const facilityId = this.inMemoryStorage.get('facilityId');

        const companyId = this.inMemoryStorage.get('company') || '';
        console.log('Fetching facilities for companyId:', companyId);
        this.http
            .get<any[]>(`${environment.apiUrl}facilities/LstFacility?company=${companyId}`)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    // Use label/value structure for dropdown
                    this.facilities = data.map((f) => ({
                        label: `${f.FACI} - ${f.FACN}`,
                        value: f.FACI
                    }));
                    this.filteredFacilities = this.facilities;
                    this.product.facilityId = facilityId;
                },
                error: () => {
                    this.product.facilityId = facilityId;

                    this.facilities = [];
                    this.filteredFacilities = [];
                    this.facilityLoading = false;
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load facilities.', life: 4000 });
                }
            });
    }

    selectedWarehouseCountryCode: string = '';
    fetchWarehouses() {
        const warehouseId = this.inMemoryStorage.get('warehouseId') || '400';

        const companyId = this.inMemoryStorage.get('company') || '080';
        console.log('Fetching warehouses for companyId:', companyId);
        this.http
            .get<any[]>(`${environment.apiUrl}facilities/LstWarehouses?company=${companyId}`)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    console.log('Warehouses API response:', data);
                    console.log(this.product, 'Before setting warehouseId');

                    console.log(data.length, 'warehouses found');
                    this.product.warehouseId = warehouseId;

                    // Use label/value structure for dropdown

                    // const cscd = data?.[0]?.cscd ?? '';
                    // console.log('Extracted cscd value:', cscd);
                    if (data.length >= 0) {
                        this.warehouses = data.map((w) => ({
                            label: `${w.whlo} - ${w.whnm}`,
                            value: w.whlo,
                            cscd: w.cscd
                        }));
                        this.filteredWarehouses = this.warehouses;
                        console.log(this.warehouses, 'Mapped warehouses');

                        const selectedWarehouse = this.warehouses.find((w) => w.value === this.product.warehouseId);
                        this.selectedWarehouseCountryCode = selectedWarehouse?.cscd || '';
                        console.log('Selected warehouse country code:', this.selectedWarehouseCountryCode);
                        this.calculateVatPercentage();
                    } else {
                        console.log('No warehouses found in response');
                    }
                },
                error: () => {
                    console.log(this.product.countryCode, 'country code before setting warehouseId on error');
                    this.product.warehouseId = warehouseId;

                    this.selectedWarehouseCountryCode = this.product.countryCode || '';
                    this.calculateVatPercentage();

                    console.log('Error fetching warehouses');

                    this.warehouses = [];
                    this.filteredWarehouses = [];
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load warehouses.', life: 4000 });
                }
            });
    }
    fetchOrderTypes() {
        const companyId = this.inMemoryStorage.get('company') || '';
        console.log('Fetching order types for companyId:', companyId);
        this.http
            .get<any>(`${environment.apiUrl}m3/SearchCustomer/order-type?company=${companyId}`)
            .pipe(takeUntil(this.destroy$))
            .subscribe({
                next: (data) => {
                    console.log('Order types API response:', data);

                    // Use label/value structure for dropdown
                    this.orderType = data.orderTypes.map((o: any) => ({
                        label: `${o.orderType} - ${o.description}`,
                        value: o.orderType
                    }));
                    console.log(this.orderType);

                    this.filteredOrderType = this.orderType;
                    console.log('Filtered Order Types:', this.filteredOrderType); // Debug print
                },
                error: () => {
                    this.orderType = [];
                    this.filteredOrderType = [];
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load order types.', life: 4000 });
                }
            });
    }

    // Filter methods for autocomplete
    filterFacilities(event: any) {
        const query = event.query.toLowerCase();
        this.filteredFacilities = this.facilities.filter((f) => f.label.toLowerCase().includes(query));
    }
    filterWarehouses(event: any) {
        const query = event.query.toLowerCase();
        this.filteredWarehouses = this.warehouses.filter((w) => w.label.toLowerCase().includes(query));
    }

    filterOrderType(event: any) {
        const query = event.query.toLowerCase();
        console.log('Filtering order types with query:', query); // Debug print

        console.log('Order Types before filtering:', this.orderType); // Debug print

        this.filteredOrderType = this.orderType.filter((o) => o.label.toLowerCase().includes(query));
        console.log('Filtered Order Types:', this.filteredOrderType); // Debug print
    }

    onSyncAllOrders() {
        this.confirmationService.confirm({
            message: 'Are you sure you want to sync all orders with status 10 to M3?',
            header: 'Confirm Sync All Orders',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.loaderMessageLine1 = 'Syncing orders with M3';
                this.loaderMessageLine2 = 'This may take a few minutes. Please do not close the browser.';
                this.loading = true;
                this.productService
                    .syncOrdersToM3('CustomerOrder')
                    .pipe(takeUntil(this.destroy$))
                    .subscribe({
                        next: (res) => {
                            this.loading = false;
                            this.messageService.add({
                                severity: 'success',
                                summary: 'Sync Successful',
                                detail: 'Orders synced to M3 successfully.',
                                life: 2000
                            });
                            this.refreshOrders();
                        },
                        error: (err) => {
                            this.loading = false;
                            this.messageService.add({
                                severity: 'error',
                                summary: 'Sync Failed',
                                detail: err?.error?.message || 'Failed to sync orders to M3.',
                                life: 4000
                            });
                        }
                    });
            }
        });
    }

    onDontSyncOrder() {
        if (!this.selectedProduct || !this.selectedProduct.orderNumber) {
            this.messageService.add({
                severity: 'error',
                summary: 'No Order Selected',
                detail: 'Please select an order to update.',
                life: 4000
            });
            return;
        }
        // Only allow if current status is 10
        if (this.product.status !== 10) {
            this.messageService.add({
                severity: 'warn',
                summary: 'Invalid Status',
                detail: 'Order status must be 10 to mark as Don’t Sync.',
                life: 4000
            });
            return;
        }
    }
    // In your component class
    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
        console.log('Component Orders destroyed and unsubscribed');
    }
    showCombineDialog = false;

    pickingListTypes = [
        { label: 'Frozen', value: 'frozone' },
        { label: 'NonFrozen', value: 'nonfrozone' }
    ];

    orderStatuses = [
        { label: '10', value: 10 },
        { label: '15', value: 15 },
        { label: '20', value: 20 }
    ];

    getTodayDate(): string {
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`; // 'YYYY-MM-DD'
    }

    combineDialogData = {
        pickingListType: 'Frozen', // or 'nonfrozone' as default
        fromDate: this.getTodayDate(),
        toDate: this.getTodayDate(),
        orderStatus: 10
    };

    onCombinePickingListProceed() {
        this.showCombineDialog = false;
        this.router.navigate(['/combine-picking-list'], {
            state: {
                pickingListType: this.combineDialogData.pickingListType,
                fromDate: this.combineDialogData.fromDate,
                toDate: this.combineDialogData.toDate,
                orderStatus: this.combineDialogData.orderStatus
            }
        });
    }
    vatPercentage: number = 0;
    calculateVatPercentage() {
        console.log('Calculating VAT Percentage with txap:', this.product.txap);

        const txap = Number(this.product.txap);
        if (txap === 0) {
            this.vatPercentage = 0;
            this.product.shouldFetchVatPercentage = false;
            console.log('VAT Percentage set to 0 due to txap = 0');
            return;
        }

        if (txap === 1) {
            let customerCountryCode = '';
            console.log('Calculating VAT Percentage with txap = 1', this.product);

            if (this.product.addressId && this.addresses.length > 0) {
                console.log(this.addresses);
                console.log('Address ID:', this.product.addressId);

                const selectedAddress = this.addresses.find((a) => a.addressId === this.product.addressId);
                console.log('Selected address for VAT calculation:', selectedAddress);

                customerCountryCode = selectedAddress?.full?.countryCode || '';

                console.log('Customer country code from selected address:', customerCountryCode);
            } else {
                customerCountryCode = this.product.countryCode || '';
                console.log('Customer country code from base details:', customerCountryCode);
            }

            const warehouseCountryCode = this.selectedWarehouseCountryCode;
            console.log('Selected warehouse country code:', warehouseCountryCode);

            if (customerCountryCode && warehouseCountryCode && customerCountryCode === warehouseCountryCode) {
                console.log('Country codes match:', customerCountryCode, warehouseCountryCode);

                this.product.shouldFetchVatPercentage = true;
                console.log('Country codes match. VAT percentage API will be called.');
            } else {
                this.product.shouldFetchVatPercentage = false;
                console.log('Country codes do not match. VAT percentage API will not be called.');
                this.vatPercentage = 0;
            }
        }
    }
    clear(dt: any) {
        dt.clear();
    }
}
